import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, defineMessages} from 'react-intl';

import {connect, ssr_wait} from '@stubhub/react-store-provider';

import SeoInternalLinks from '../react-seo-internal-links';

import controller from './controller';

import './index.scss';

const messages = defineMessages({
  nearbyVenuesTitle: {
    id: 'NearbyVenues.title',
    defaultMessage: 'Venues near {entityName}',
    description: 'View all venues nearby',
  },
});

class NearbyVenues extends React.Component {
  @ssr_wait
  init() {
    const {loadNearbyVenues} = this.props;

    return loadNearbyVenues(this.props);
  }

  UNSAFE_componentWillMount() {
    const {venueLinks} = this.props;
    if (!venueLinks || venueLinks.length === 0) {
      this.init();
    }
  }

  componentWillUnmount() {
    const {resetNearbyVenues} = this.props;
    resetNearbyVenues();
  }

  render() {
    const {venueLinks, entityType, entityId, entityName, intl} = this.props;
    const title = intl.formatMessage(messages.nearbyVenuesTitle, {entityName});

    return (
      <div className="SeoNearbyVenues">
        <SeoInternalLinks seoLinks={venueLinks} entityType={entityType} entityId={entityId} title={title} />
      </div>
    );
  }
}

NearbyVenues.propTypes = {
  entityName: PropTypes.string,
  entityId: PropTypes.number,
  entityType: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  lat: PropTypes.number,
  // eslint-disable-next-line react/no-unused-prop-types
  lng: PropTypes.number,
  venueLinks: PropTypes.array,
  loadNearbyVenues: PropTypes.func.isRequired,
  resetNearbyVenues: PropTypes.func.isRequired,

  /** The intl object */
  intl: PropTypes.object.isRequired,
};

export {NearbyVenues};

export default injectIntl(connect(controller)(NearbyVenues));
